export enum HelpItemTypeEnum {
    DOCUMENT = 1,
    VIDEO = 2
}
